import classNames from 'classnames';

import styles from '../Document.module.scss';

type Props = {
    filePreview: string;
    extraStyles? :boolean;
}

const DocumentPreview = ({ filePreview, extraStyles }: Props): JSX.Element => (
  <div className={classNames([styles.fileUpload, styles.hasPreview, { [styles.extraFileUpload]: extraStyles }])}>
    <div className={classNames(styles.fileUploadPreview, { [styles.extrafileUploadPreview]: extraStyles })}>
      <span className={classNames(styles.fileUploadRender, { [styles.extrafileUploadRender]: extraStyles })}>
        <img
          alt=""
          src={filePreview as string}
          className={classNames(styles.fileUploadPreviewImg, { [styles.extrafileUploadPreviewImg]: extraStyles })}
        />
      </span>
    </div>
  </div>
);
export default DocumentPreview;
